export const INVENTORY_TYPES = {
  general: {
    label: 'General', blurb: 'Any stock you buy and use.', pour: false, fields: [], listFields: [],
  },
  bar: {
    label: 'Bar / Bottle shop', blurb: 'Drinks by the bottle, case or pour — with mixers, sell prices and margin alerts.', pour: true,
    fields: [], listFields: [],
  },
  restaurant: {
    label: 'Restaurant / Cafe', blurb: 'Ingredients and consumables with yield, wastage, storage and expiry.', pour: false,
    fields: [
      { key: 'yield_pct', label: 'Usable yield %', type: 'number', placeholder: 'e.g. 85 (after trimming)' },
      { key: 'wastage_pct', label: 'Typical wastage %', type: 'number' },
      { key: 'storage_temp', label: 'Storage', type: 'select', options: ['Ambient', 'Chilled', 'Frozen', 'Dry store'] },
      { key: 'allergens', label: 'Allergens', type: 'text', placeholder: 'gluten, nuts, dairy' },
    ],
    listFields: ['storage_temp', 'yield_pct'],
  },
  warehouse: {
    label: 'Warehouse / Distribution', blurb: 'Bin locations, pallet quantities, weights and dimensions.', pour: false,
    fields: [
      { key: 'bin_location', label: 'Bin / shelf', type: 'text', placeholder: 'A-03-2' },
      { key: 'pallet_qty', label: 'Units per pallet', type: 'number' },
      { key: 'weight_kg', label: 'Weight (kg)', type: 'number' },
      { key: 'length_cm', label: 'Length (cm)', type: 'number' },
      { key: 'width_cm', label: 'Width (cm)', type: 'number' },
      { key: 'height_cm', label: 'Height (cm)', type: 'number' },
    ],
    listFields: ['bin_location', 'pallet_qty'],
  },
  chemical: {
    label: 'Chemical / Cleaning', blurb: 'Hazard details, safety data sheets, storage, batch and expiry.', pour: false,
    fields: [
      { key: 'hazard_class', label: 'Hazard class', type: 'select', options: ['Not dangerous goods', '2 Gases', '3 Flammable liquids', '4 Flammable solids', '5 Oxidisers', '6 Toxic', '8 Corrosive', '9 Miscellaneous'] },
      { key: 'un_number', label: 'UN number', type: 'text', placeholder: 'UN1791' },
      { key: 'packing_group', label: 'Packing group', type: 'select', options: ['', 'I', 'II', 'III'] },
      { key: 'sds_url', label: 'Safety data sheet link', type: 'url', placeholder: 'https://…' },
      { key: 'sds_review_date', label: 'SDS review date', type: 'date' },
      { key: 'storage_requirements', label: 'Storage requirements', type: 'text', placeholder: 'Keep away from acids' },
      { key: 'ppe_required', label: 'PPE required', type: 'text', placeholder: 'Gloves, goggles' },
    ],
    listFields: ['hazard_class', 'un_number'],
    expiryDefault: true,
  },
  construction: {
    label: 'Construction / Trades', blurb: 'Materials and tools by job and cost code, with serial numbers and service dates.', pour: false,
    fields: [
      { key: 'job_number', label: 'Job number', type: 'text' },
      { key: 'cost_code', label: 'Cost code', type: 'text' },
      { key: 'is_tool', label: 'Tool / plant item', type: 'checkbox' },
      { key: 'serial_number', label: 'Serial number', type: 'text', toolOnly: true },
      { key: 'assigned_to', label: 'Assigned to', type: 'text', toolOnly: true },
      { key: 'service_due', label: 'Service / test & tag due', type: 'date', toolOnly: true },
    ],
    listFields: ['job_number', 'cost_code'],
  },
};

export const TYPE_FIELD_KEYS = [...new Set(Object.values(INVENTORY_TYPES).flatMap((t) => t.fields.map((f) => f.key)))];
export const typeOf = (key) => INVENTORY_TYPES[key] || INVENTORY_TYPES.general;
export const fieldLabel = (type, key) => (typeOf(type).fields.find((f) => f.key === key) || {}).label || key;
